import Mailcheck from 'mailcheck';
import { bubEvents } from 'shared/events/bub_events';

export const emailSuggestorUtils = {
  mountEmailSuggestor(emailInput, emailSuggestionContainer, emailCorrection, eventCategory) {
    let suggestedEmail = '';

    emailInput.on('blur', () => {
      Mailcheck.run({
        email: emailInput.val(),
        suggested: suggestion => {
          suggestedEmail = suggestion.full;

          emailSuggestionContainer.addClass('has-suggestion');
          emailCorrection.text(suggestedEmail);
          emailCorrection.attr('aria-label', `Did you mean: ${suggestedEmail}?`);
          emailCorrection.focus();

          bubEvents.track(eventCategory, 'email correction', {
            label: 'suggested',
          });
        },
        empty: () => {
          suggestedEmail = '';

          emailSuggestionContainer.removeClass('has-suggestion');
          emailCorrection.text('');
        },
      });
    });

    emailCorrection.on('click', () => {
      emailInput.val(suggestedEmail);
      emailSuggestionContainer.removeClass('has-suggestion');
      emailCorrection.text('');
      emailCorrection.removeAttr('aria-label');

      bubEvents.track(eventCategory, 'email correction', {
        label: 'applied',
      });
    });
  },
};
